<div class="container">
  <div class="card mt-5">
    <div
      class="card-header d-flex flex-lg-row flex-column justify-content-between"
    >
      <h3 class="card-title">
        <i
          class="bi bi-arrow-left-circle"
          routerLink="/dashboard"
          style="cursor: pointer"
        ></i>
        Rutinas - {{ selectedUser?.firstName }}&nbsp;{{
          selectedUser?.lastName
        }}
      </h3>

      <button
        class="btn-custom"
        data-bs-toggle="modal"
        data-bs-target="#routineGroupFormModal"
        (click)="editingRoutineGroup = false"
      >
        Crear Nueva Rutina
      </button>
    </div>
    <div class="card-body">
      <div class="accordion accordion-flush" id="accordion">
        <div class="accordion-item" *ngFor="let routineGroup of routineGroups">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#collapse' + routineGroup.id"
              [attr.aria-controls]="'collapse' + routineGroup.id"
              aria-expanded="false"
              (click)="selectGroup(routineGroup)"
            >
              <span>{{ routineGroup.name }}</span>

              <div>
                <span
                  class="ms-2 progress-pill"
                  *ngIf="
                    routineGroup.status == 'IN_PROGRESS' && !routineGroup.isOwn
                  "
                  >En Progreso 💪🏼</span
                >
              </div>

              <div>
                <span class="ms-2 is-own-pill" *ngIf="routineGroup.isOwn"
                  >Creada por usuario</span
                >
              </div>

              <i
                class="bi bi-pencil-square mx-lg-3 mx-2"
                *ngIf="routineGroup.status == 'IN_PROGRESS'"
                data-bs-toggle="modal"
                data-bs-target="#routineGroupFormModal"
                (click)="
                  selectedRoutineGroup = routineGroup;
                  editingRoutineGroup = true
                "
              ></i>
            </button>
          </h2>
          <div
            [id]="'collapse' + routineGroup.id"
            data-bs-parent="#accordion"
            class="accordion-collapse collapse"
          >
            <div class="accordion-body">
              <div class="" *ngIf="accordionMode == 'list'">
                <div
                  class="d-flex flex-lg-row flex-column justify-content-between"
                >
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-row align-items-center">
                      <h6>Vigencia: &nbsp;</h6>
                      <span>
                        {{ routineGroup.startAtParsed }}&nbsp;-&nbsp;
                      </span>
                      <span *ngIf="!routineGroup.finishAt" class="me-3"
                        >presente</span
                      ><span *ngIf="routineGroup.finishAt" class="">{{
                        routineGroup.finishAtParsed
                      }}</span>
                    </div>

                    <div class="d-flex flex-row">
                      <h6>Nivel de Experiencia: &nbsp;</h6>
                      <span>{{ routineGroup.experienceLabel }}</span>
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <button
                      class="btn-custom mb-3 me-1"
                      (click)="openCalendarModal()"
                    >
                      Calendario
                    </button>
                    <button
                      class="btn-custom-outline mb-3 me-1"
                      (click)="getRoutineGroupProgretion(routineGroup)"
                    >
                      <div
                        *ngIf="routineGroup.sendingEmail"
                        class="spinner-border"
                        role="status"
                      >
                        <span class="visually-hidden">Loading...</span>
                      </div>
                      <span *ngIf="!routineGroup.sendingEmail"
                        >Progresiones</span
                      >
                    </button>

                    <div *ngIf="routineGroup.status == 'IN_PROGRESS'">
                      <button
                        class="btn btn-danger mb-3"
                        (click)="finishRoutineGroup()"
                      >
                        Finalizar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div
                    class="routineModel p-2 m-1 w-100 rounded-2 row"
                    *ngFor="let routineModel of routineGroup.routines"
                  >
                    <div
                      class="col-6 d-flex align-items-center"
                      data-bs-toggle="modal"
                      data-bs-target="#routineDayFormModal"
                      style="cursor: pointer"
                      (click)="watchRoutineDetail(routineModel)"
                    >
                      <span *ngIf="routineModel.dayOfWeek"
                        >{{ routineModel.name }} -
                        {{ routineModel.dayOfWeek | dayOfWeekTransform }}</span
                      >

                      <span *ngIf="!routineModel.dayOfWeek"
                        >{{ routineModel.name }} - Sin día asignado
                      </span>
                    </div>

                    <div
                      class="col-6 d-flex justify-content-end align-items-center"
                    >
                      <i
                        class="bi bi-pencil-square mx-lg-3 mx-2"
                        data-bs-toggle="modal"
                        data-bs-target="#routineDayFormModal"
                        *ngIf="
                          routineGroup.status == 'IN_PROGRESS' &&
                          routineModel.status == 'CREATED'
                        "
                        style="cursor: pointer"
                        (click)="editRoutineModel(routineModel)"
                      ></i>
                      <i
                        class="bi bi-pencil-square mx-lg-3 mx-2"
                        *ngIf="
                          routineGroup.status == 'IN_PROGRESS' &&
                          routineModel.status == 'STARTED'
                        "
                        style="cursor: pointer; color: grey"
                        (click)="routineModelStartedEditError()"
                      ></i>
                      <i
                        class="bi bi-trash mx-lg-3 mx-2"
                        style="color: red; cursor: pointer"
                        *ngIf="routineGroup.status == 'IN_PROGRESS'"
                        (click)="deleteRoutineModel(routineModel, routineGroup)"
                      ></i>
                    </div>
                  </div>
                  <button
                    class="w-100 btn btn-outline-warning m-1"
                    data-bs-toggle="modal"
                    data-bs-target="#routineDayFormModal"
                    (click)="createRoutineModel()"
                    *ngIf="routineGroup.status == 'IN_PROGRESS'"
                  >
                    +
                  </button>

                  <button
                    class="w-100 btn btn-outline-secondary m-1 import-button"
                    (click)="openImportUserSelectorModal(routineGroup)"
                    *ngIf="routineGroup.status == 'IN_PROGRESS'"
                  >
                    Importar rutina
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-routine-day-form-modal
  *ngIf="selectedGroup"
  [(editingRoutineDay)]="editing"
  [(routineModelToEdit)]="selectedRoutineModel"
  [routineGroupId]="selectedGroup.id!"
  [(watching)]="watching"
  (routineModelCreated)="onRoutineModelCreated($event)"
></app-routine-day-form-modal>

<app-routine-group-form-modal
  (formUpdatedDb)="routineGroupCreatedOrUpdated()"
  [routineGroup]="selectedRoutineGroup"
  [editing]="editingRoutineGroup"
></app-routine-group-form-modal>

<app-import-user-selector
  (modalHidden)="getUserRoutines()"
></app-import-user-selector>

<app-workout-calendar
  [routineGroupId]="selectedGroup?.id"
></app-workout-calendar>
